import { Component, OnInit, OnDestroy, ChangeDetectorRef, ChangeDetectionStrategy } from "@angular/core";
import { Location } from "@angular/common";
import { CoreLogService } from "../../services/log.service";
import { ActivatedRoute, Router } from "@angular/router";
import { MainnavService, ViewType } from "../mainNav/mainnav.service";
import { WebShopService } from "../../services/webShop.service";
import { CoreLanguageService } from "../../services/language.service";
import { InternationalisationService } from "../../forked/angular-internationalisation";
import { Subscription } from "rxjs/Subscription";
import { Observable } from "rxjs";
import { slideInFade } from "../../shared/animation/component.animation";
import { RemoteOrderGroupMemberDetailService } from "./remoteOrderGroupMemberDetail.service";
import { IRemoteGroupMember, IRemoteGroupMemberItems } from "./remoteOrderGroupMemberDetail.facade";
import { MatCheckboxChange } from "@angular/material";
import { EventmanagerService } from "../../services/eventmanager.service";
import { take } from "rxjs/operators";

@Component({
  selector: "remoteOrderGroupMemberDetail",
  templateUrl: "./remoteOrderGroupMemberDetail.component.html",
  styleUrls: ["./remoteOrderGroupMemberDetail.component.scss"],
  providers: [RemoteOrderGroupMemberDetailService],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [slideInFade]
})

export class RemoteOrderGroupMemberDetailComponent implements OnInit, OnDestroy {
  private _langSubscriber: Subscription;
  public isSmallView: boolean = false;
  public currentOpenCommentId: number | null = null;
  public currentUserId: string = "";
  public groupMember$: Observable<IRemoteGroupMember>;
  public groupMemberItems$: Observable<IRemoteGroupMemberItems[]>;
  public isOwner: boolean = false;

  constructor(private _location: Location
    , private _router: Router
    , private _changeDetectorRef: ChangeDetectorRef
    , private _coreLogService: CoreLogService
    , private _coreLanguageService: CoreLanguageService
    , private _mainnavService: MainnavService
    , private internationalisationService: InternationalisationService
    , private _webShopService: WebShopService
    , private _remoteOrderGroupMemberDetailService: RemoteOrderGroupMemberDetailService
    , private _activatedRoute: ActivatedRoute
    , private _eventManagerService: EventmanagerService

  ) {
    const me = this;
    me.isSmallView = me._mainnavService.viewType === ViewType.Small;
  }

  ngOnInit() {
    const me = this;
    me._activatedRoute.paramMap.subscribe(params => {
      me.currentUserId = params.get("userId");
    });

    me._remoteOrderGroupMemberDetailService.initial(me.currentUserId).then(() => {
      me.isOwner = me._remoteOrderGroupMemberDetailService.isOwner;
      me.validateEventAndOpenDialog();
      me.PushChanges();
    }).catch((error) => {
      me._coreLogService.error("RemoteOrderGroupMemberDetailComponent.ngOnInit", "_RemoteOrderGroupMemberDetailService.initial catch", error);
    })
    me.groupMember$ = me._remoteOrderGroupMemberDetailService.groupMember$;
    me.groupMemberItems$ = me._remoteOrderGroupMemberDetailService.groupMemberItems$;
    me._langSubscriber = me.internationalisationService.localeChanged.subscribe(() => {
      me.PushChanges();
    });
  }

  ngOnDestroy(): void {
    const me = this;
    if (me._langSubscriber) {
      me._langSubscriber.unsubscribe();
    }
  }

  private PushChanges(): void {
    try {
      this._changeDetectorRef.detectChanges();
    } catch (e) {
      this._coreLogService.error("RemoteOrderGroupOverviewComponent.PushChanges", "_changeDetectorRef.detectChanges (catch)", e);
    }
  }

  public trackMemberOverviewBy(member: IRemoteGroupMember) {
    return member.userId;
  }

  public setHeaderLabelGuest(memberName: string): string {
    const key = this._coreLanguageService.value("phRemoteOrder_MemberOrder_Detail_Guest_Label");
    return key.replace("{name}", `<span class="emphasized">${memberName}</span>`);
  }

  public itemsCount(items: number): string {
    return items.toString();
  }

  public itemsAmount(amount: number) {
    const me = this;
    return me._webShopService.formatCurrency(amount);
  }

  /** change state "Ready" */
  public async changeStateReady(userId: number, event: MatCheckboxChange) {
    const me = this;
    await me._remoteOrderGroupMemberDetailService.changeStateReady(userId, event.checked);
    me.PushChanges();
  }

  /**
   * Navigates to the menu detail.
   * 
   * @param {number} basketItemid - The ID of the basket item to view details for.
   */
  public viewDetails(basketItemid: number) {
    const me = this;
    const currentLocation = me._webShopService.locationID;
    me._router.navigate(["menudetail", -1, basketItemid, currentLocation]);
  }

  public validateEventAndOpenDialog() {
    const me = this;
    me._webShopService.handleEventPE().then(() => {
      let hasPeChanged: boolean = false;
      me._webShopService.peChanged$.pipe(take(1)).subscribe(value => hasPeChanged = value).unsubscribe();
      if (hasPeChanged) {
        const showChangeDialog = me._webShopService.recalcServicePeInBasket();
        if (showChangeDialog) {
          me._eventManagerService.OpenPriceChangeDialog(true);
        }
        me.PushChanges();
      }
    }).catch((error) => {
      me._coreLogService.error("RemoteOrderGroupMemberDetailComponent.validateEventAndOpenDialog", "_webShopService.handleEventPE catch", error);
    });

  }

  /** navigate back on swipe from left to right */
  public SwiperNavigateBack() {
    const me = this;
    if (me.isSmallView == true) {
      me.navigateBack();
    }
  }

  /** navigate back */
  public navigateBack(): void {
    this._location.back();
  }
}